export default "__VITE_ASSET__Bg6dv0BM__"